import React from 'react';
import { Box, Typography } from '@availity/element';
import Animation from '../../Utils/components/Animation';
import { typography } from '../../../static/constants/typography';

const DirectToPayerSection = () => (
  <Box className="direct-to-payer">
    <Box className="direct-to-payer__container">
      <Box className="direct-to-payer__header">
        <Typography className="section-subtitle" sx={typography.latoRegular18}>Direct To Payer</Typography>
        <Typography className="direct-to-payer__title">
          Operate at Scale with Network-Powered API Access
        </Typography>
      </Box>
      <Box className="direct-to-payer__content">
        <Box className="direct-to-payer__text-column">
          <Typography className="text--white" sx={typography.latoRegular18}>
            Connect to Availity APIs and gain direct access to our expansive payer network &mdash; no intermediaries or additional hops needed &mdash; and operate at network scale from day one.
          </Typography>
          <Typography className="text--white" sx={typography.latoRegular18}>
            Covering pre&#8209;service, point-of-care, and post-service workflows, Availity APIs replace static integrations with intelligent, automated workflows that power traditional applications and enable agent-driven experiences.
          </Typography>
        </Box>
        <Box className="direct-to-payer__animation-column">
          <Animation
            src="/static/assets/illustrations/Animation _ Direct to Payer.html"
            sx={{ width: '100%', aspectRatio: '602 / 297' }}
          />
        </Box>
      </Box>
    </Box>
  </Box>
);

export default DirectToPayerSection;
